import Query from "@qpr/client-api-base/querybuilder/Query";
import { IScoreCard } from "./model";

export const getChildScorecards = async (id: string) => {
  return Query(id)
    .childobjects()
    .attributes("name", "level", "symbol")
    .fetchValues<IScoreCard>();
};
